import { MessageableFactory, SignalableFactory } from '@locumsnest/core/src';

const namespace = 'Firebase';

const messageableFactory = MessageableFactory.forFeature<typeof namespace>(namespace);
const signalableFactory = SignalableFactory.forFeature<typeof namespace>(namespace);

export { messageableFactory, signalableFactory };
